import {
  ArrowRightOutlined,
  InfoCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons';
import { Col, Divider, notification, Row } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import FiltroPeriodo from '../../../components/FiltroPeriodo';
import InfoPopover from '../../../components/InfoPopover';
import { carregaCidadesPorId } from '../../../helpers/cidades';
import {
  formatarCnpjCpfIMask,
  formatarMilhar,
  formatarMoedaIMask,
  formatarPorcentagem,
} from '../../../helpers/formatador';
import { filtraHorarioEmbarque } from '../../../helpers/loteHorariosEmbarque';
import { useAuth } from '../../../security/authContext';
import { checkPermission } from '../../../security/Can';
import apiNetCore from '../../../services/apiNetCore';
import { Message, TextColor } from '../../../styles/global';
import TipoDirecionamentoEnum from '../../Demanda/Enum/TipoDirecionamentoEnum';
import HistoricoDeCarregamento from './HistoricoDeCarregamento';
import HistoricoDeFreteNoLote from './HistoricoDeFreteNoLote';
import MiniCard from './MiniCard';
import ModalFinalizarLote from './Modal/modalFinalizarLote';
import {
  Button,
  Card,
  Item,
  ItemPopover,
  Status,
  SubTitle,
  Text,
  Title,
} from './styles';

function DadosGerais({ dadosLote }) {
  const history = useHistory();

  const { user } = useAuth();

  const [especie, setEspecie] = useState('');
  const [produto, setProduto] = useState('');
  const [aderencia, setAderencia] = useState(0);
  const [cadenciaDia, setCadenciaDia] = useState(0);
  const [saldoLote, setSaldoLote] = useState(0);
  const [isMarketplace, setIsMarketplace] = useState(false);
  const [volumeTonelada, setVolumeTonelada] = useState(0);
  const [dataFimLote, setDataFimLote] = useState();
  const [dataInicioLote, setDataInicioLote] = useState();
  const [loading, setLoading] = useState(false);

  const [statusLote, setStatus] = useState('');
  const [valorPedagio, setValorPedagio] = useState(0);
  const [horariosEmbarqueFormated, setHorariosEmbarqueFormated] = useState([]);
  const [showModalFinalizarLote, setShowModalFinalizarLote] = useState(false);

  const [cidadeDestino, setCidadesDestino] = useState('');
  const [cidadeExpedidor, setCidadeExpedidor] = useState('');
  const [cidadeOrigem, setCidadeOrigem] = useState('');
  const [cidadeRecebedor, setCidadeRecebedor] = useState('');
  const [dataInicioPeriodo, setdataInicioPeriodo] = useState(null);
  const [dataFimPeriodo, setdataFimPeriodo] = useState(null);
  const [dataInicioPeriodoFrete, setdataInicioPeriodoFrete] = useState(null);
  const [dataFimPeriodoFrete, setdataFimPeriodoFrete] = useState(null);
  const [cnpjPagadorValue, setCnpjPagador] = useState(null);
  const [idLoteValue, setIdLote] = useState(null);

  const handleDatasFiltro = (dIncio, dFinal) => {
    setdataInicioPeriodo(dIncio);
    setdataFimPeriodo(dFinal);
  };

  const handleDatasFiltroFrete = (dIncio, dFinal) => {
    setdataInicioPeriodoFrete(dIncio);
    setdataFimPeriodoFrete(dFinal);
  };

  const detalhesLoteAnalytics = async () => {
    if (!dadosLote.idLote) return;
    try {
      setLoading(true);
      const { data } = await apiNetCore.get(
        `/lotes-integracao/detalhamento-analitico/${dadosLote.idLote}`
      );

      setVolumeTonelada(data.volumeTonelada);
      setSaldoLote(data.saldoLote);
      setCadenciaDia(data.cadenciaDia);
      setAderencia(data.aderencia);
      setProduto(data.produto);
      setEspecie(data.especie);
    } catch ({ response }) {
      notification.error({
        message: 'Não possível carregar os detalhes do lote.',
        description:
          'Se o problema persistir por favor entre em contato com o suporte.',
      });
    }
    setLoading(false);
  };

  const getPedagioRota = endereco =>
    apiNetCore.post('/lotes-integracao/pedagio-rota', endereco);

  const capitalize = text =>
    text.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());

  const formatarNomeCidade = cidade => {
    if (!cidade) return '';
    return `${capitalize(cidade.cidadeNome)} - ${cidade.sigla}`;
  };

  const onClickEditLote = () => {
    history.push(`/lotes/${dadosLote.idLote}`);
  };

  const onClickAnaliseFrete = () => {
    const origem = cidadeExpedidor[0] || cidadeOrigem[0];
    const destino = cidadeRecebedor[0] || cidadeDestino[0];

    history.push(
      `/precificacao/${origem.cidadeNome}/${destino.cidadeNome}/${produto}`
    );
  };

  const onClickMapaMotorista = () => {
    const origem = cidadeExpedidor[0] || cidadeOrigem[0];

    history.push(`/mapa-gerenciamento/${origem.cidadeNome}`);
  };

  const onClickFinalizar = () => {
    setShowModalFinalizarLote(true);
  };

  const handleFinalizarLote = async () => {
    if (!dadosLote.idLote) return;
    try {
      const { data } = await apiNetCore.put(
        `/lotes-integracao/finalizar/${dadosLote.idLote}`
      );

      setStatus(data.statusLote);

      notification.success({
        message: 'Tudo certo',
        description: 'Lote finalizado com sucesso.',
      });
    } catch ({ response }) {
      notification.error({
        message: 'Não foi possível finalizar o lote.',
        description:
          'Se o problema persistir por favor entre em contato com o suporte.',
      });
    }
  };

  const dataInicioFim = () => {
    if (!dadosLote) return '';

    const dataInicio = moment(dadosLote.dataInicio).format('DD/MM/YYYY');
    const dataFim = moment(dadosLote.dataFim).format('DD/MM/YYYY');

    if (!dadosLote.dataFim) return `${dataInicio}`;

    return `${dataInicio} à ${dataFim}`;
  };

  const formatarEndereco = (enderecoObj, cidade) => {
    if (!enderecoObj || cidade.length <= 0) return;

    const { bairro, cep, complemento, endereco, numero } = enderecoObj;

    const rua = endereco ? `${endereco} ${numero || ''}` : '';
    const address = [
      complemento,
      rua,
      bairro,
      cep,
      formatarNomeCidade(cidade[0]),
    ].filter(Boolean);

    return address.join(' - ');
  };

  const formataCnpj = cnpj => {
    if (!cnpj) return '-';
    return formatarCnpjCpfIMask(cnpj);
  };

  useEffect(() => {
    async function onInit() {
      if (Object.values(dadosLote).length === 0) return;

      const {
        enderecoDestino,
        enderecoExpedidor,
        enderecoOrigem,
        enderecoRecebedor,
        dataFim,
        dataInicio,
        dadoPagador,
        idLote,
        tipoDirecionamento,
      } = dadosLote;

      const pagadorCnpjResumido = dadoPagador?.cnpj.substr(0, 8);

      setCnpjPagador(pagadorCnpjResumido);
      setIdLote(idLote);
      setDataFimLote(moment(dataFim));
      setDataInicioLote(moment(dataInicio));
      setIsMarketplace(
        tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE
      );

      carregaCidadesPorId(enderecoDestino.cidade, setCidadesDestino, () => {});
      carregaCidadesPorId(
        enderecoExpedidor.cidade,
        setCidadeExpedidor,
        () => {}
      );
      carregaCidadesPorId(enderecoOrigem.cidade, setCidadeOrigem, () => {});
      carregaCidadesPorId(
        enderecoRecebedor.cidade,
        setCidadeRecebedor,
        () => {}
      );

      const endereco = [
        {
          idCidadeOrigem: enderecoExpedidor.cidade || enderecoOrigem.cidade,
          idCidadeDestino: enderecoRecebedor.cidade || enderecoDestino.cidade,
        },
      ];

      getPedagioRota(endereco).then(({ data }) =>
        setValorPedagio(data[0].pedagio)
      );

      setHorariosEmbarqueFormated(
        filtraHorarioEmbarque(dadosLote.horariosEmbarque)
      );

      setStatus(dadosLote.status);

      detalhesLoteAnalytics();
    }
    onInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosLote]);

  const showTagsContent = (loadingContent, value) => {
    if (loadingContent) {
      return <LoadingOutlined style={{ fontSize: 20 }} spin />;
    }

    if (value) {
      return value;
    }

    return 0;
  };

  const LoadingMiniCards = () => {
    const possibleAttrs = [
      {
        key: 1,
        title: 'Volume',
        field: `${formatarMilhar(volumeTonelada, 0, false)} Ton`,
      },
      {
        key: 2,
        title: 'Saldo do lote',
        field: `${formatarMilhar(saldoLote, 0, false)} Ton`,
      },
      {
        key: 3,
        title: 'Cadência do dia',
        field: `${formatarMilhar(cadenciaDia, 0, false)} Ton`,
      },
      {
        key: 4,
        title: 'Aderência',
        field: formatarPorcentagem(aderencia),
      },
      {
        key: 5,
        title: 'Produto',
        field: `${produto}`,
      },
      {
        key: 6,
        title: 'Espécie',
        field: `${especie}`,
      },
    ];

    return possibleAttrs.map(({ key, title, field }) => (
      <MiniCard
        key={key}
        title={title}
        value={field}
        showTagsContent={showTagsContent}
        loading={loading}
      />
    ));
  };

  const custoFrete = (valorPf, valorPj) => {
    if (valorPf === valorPj) {
      return <SubTitle>{formatarMoedaIMask(valorPf)}</SubTitle>;
    }
    return (
      <>
        <SubTitle>
          {formatarMoedaIMask(valorPf)}
          &nbsp; (PF)
        </SubTitle>
        <SubTitle>
          {formatarMoedaIMask(valorPj)}
          &nbsp; (PJ)
        </SubTitle>
      </>
    );
  };

  const renderPopOverContent = stringContent => (
    <InfoPopover
      placement="right"
      content={<ItemPopover>{stringContent}</ItemPopover>}
    >
      <InfoCircleFilled />
    </InfoPopover>
  );

  return (
    <>
      <ModalFinalizarLote
        setShowModalFinalizarLote={setShowModalFinalizarLote}
        showModalFinalizarLote={showModalFinalizarLote}
        finalizarLote={handleFinalizarLote}
      />
      <Row>
        <LoadingMiniCards />
      </Row>
      <Divider />

      <Row align="center" justify="space-between">
        <Item>
          Status do lote:
          <Status>
            <SubTitle className={statusLote}>{statusLote}</SubTitle>
          </Status>
        </Item>
        {isMarketplace && checkPermission(user.permissions, 'lotes:edit') && (
          <Col>
            <Button className="mr-15" onClick={onClickEditLote} color="#4190F7">
              Editar lote
            </Button>
            {/*
            <Button color="#E47515" className="ml-15 mr-15">
              Pausar lote
            </Button>
            */}
            <Button
              onClick={onClickFinalizar}
              disabled={statusLote === 'Finalizado'}
              color="#24A95D"
            >
              Finalizar lote
            </Button>
          </Col>
        )}
      </Row>
      <Divider />

      <Row justify="space-between" align="middle" className="mt-40 mb-40">
        <Col span={11}>
          <Card>
            <Title>Cliente pagador</Title>
            <SubTitle>
              {dadosLote?.dadoPagador?.razao_social &&
                dadosLote.dadoPagador.razao_social}
              &nbsp;
              {formataCnpj(
                dadosLote?.dadoPagador?.cnpj && dadosLote.dadoPagador.cnpj
              )}
            </SubTitle>
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <Title>Tipo de lote</Title>
            {dadosLote.tipoDirecionamento && (
              <SubTitle>
                {
                  TipoDirecionamentoEnum.getTipo(dadosLote.tipoDirecionamento)
                    .label
                }
              </SubTitle>
            )}
          </Card>
        </Col>
      </Row>

      <Row justify="space-between" align="middle" className="mt-40 mb-40">
        <Col span={11}>
          <Card>
            <Title>
              Remetente
              {renderPopOverContent(
                formatarEndereco(dadosLote.enderecoOrigem, cidadeOrigem)
              )}
            </Title>
            <SubTitle>
              {dadosLote.clienteOrigem}
              &nbsp;
              {formataCnpj(dadosLote.cnpjClienteOrigem)}
            </SubTitle>

            <Title>
              Expedidor
              {renderPopOverContent(
                formatarEndereco(dadosLote.enderecoExpedidor, cidadeExpedidor)
              )}
            </Title>
            <SubTitle>
              {dadosLote.clienteExpedidor}
              &nbsp;
              {formataCnpj(dadosLote.cnpjClienteExpedidor)}
            </SubTitle>
          </Card>
        </Col>
        <Item span={1}>
          <ArrowRightOutlined style={{ fontSize: 20 }} />
        </Item>
        <Col span={12}>
          <Card>
            <Title>
              Destinatário
              {renderPopOverContent(
                formatarEndereco(dadosLote.enderecoDestino, cidadeDestino)
              )}
            </Title>
            <SubTitle>
              {dadosLote.clienteDestino}
              &nbsp;
              {formataCnpj(dadosLote.cnpjClienteDestino)}
            </SubTitle>

            <Title>
              Recebedor
              {renderPopOverContent(
                formatarEndereco(dadosLote.enderecoRecebedor, cidadeRecebedor)
              )}
            </Title>
            <SubTitle>
              {dadosLote.clienteRecebedor}
              &nbsp;
              {formataCnpj(dadosLote.cnpjClienteRecebedor)}
            </SubTitle>
          </Card>
        </Col>
      </Row>

      <Row className="mt-40 mb-40">
        <Col span={11}>
          <Card>
            <Row justify="space-between">
              <Col>
                <Title>Frete motorista:</Title>
                {isMarketplace ? (
                  custoFrete(
                    dadosLote.freteMotoristaPf,
                    dadosLote.freteMotoristaPj
                  )
                ) : (
                  <Text>-</Text>
                )}
              </Col>
              <Col>
                <Title>Custo final:*</Title>
                {custoFrete(dadosLote.freteTotalPf, dadosLote.freteTotalPj)}
              </Col>
              <Col>
                <Title>Pedágio incluso:</Title>
                <SubTitle>{dadosLote.pedagio === 1 ? 'Sim' : 'Não'}</SubTitle>
              </Col>
              <Col>
                <Title>Custo pedágio:</Title>
                <SubTitle>
                  {formatarMoedaIMask(valorPedagio.toFixed(2))}
                </SubTitle>
              </Col>
            </Row>
            <Row className="mt-10" justify="center">
              <Button onClick={onClickAnaliseFrete} color="#4190F7">
                Análise de frete e mercado
              </Button>
              <Button onClick={onClickMapaMotorista} color="#4190F7">
                Ver motoristas na região
              </Button>
            </Row>
            {isMarketplace && (
              <Row>
                <Message margin="10px 0 -10px">
                  <TextColor color="#ff0000">*</TextColor>
                  &nbsp;O ICMS e demais impostos não estão sendo considerados
                  para o cálculo do frete.
                </Message>
              </Row>
            )}
          </Card>
        </Col>
        <Col span={12} offset={1}>
          <Card>
            <Row justify="space-between">
              <Col>
                <Title>Data inicial / final</Title>
                <SubTitle>{dataInicioFim()}</SubTitle>
              </Col>
              <Col>
                <Title>Horário de carregamento</Title>
                {horariosEmbarqueFormated.map(({ key, field }) => (
                  <SubTitle key={key}>{field}</SubTitle>
                ))}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row className="mt-40 mb-40">
        <Col span={11}>
          <Card>
            <Row justify="space-between">
              <Col>
                <Title>Histórico de frete no lote</Title>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                {dataInicioLote && (
                  <FiltroPeriodo
                    handleDates={handleDatasFiltroFrete}
                    dateMin={dataInicioLote}
                    dateMax={dataFimLote}
                    rangeSize={20}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                {dataInicioPeriodoFrete && (
                  <HistoricoDeFreteNoLote
                    dataInicial={dataInicioPeriodoFrete}
                    dataFinal={dataFimPeriodoFrete}
                    loteId={idLoteValue}
                    isMarketplace={isMarketplace}
                  />
                )}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={12} offset={1}>
          <Card>
            <Row justify="space-between">
              <Col>
                <Title>Histórico de carregamento</Title>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                {dataInicioLote && (
                  <FiltroPeriodo
                    handleDates={handleDatasFiltro}
                    dateMin={dataInicioLote}
                    dateMax={dataFimLote}
                    rangeSize={20}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                {dataInicioPeriodo && (
                  <HistoricoDeCarregamento
                    tipo="DAILY"
                    dataInicial={dataInicioPeriodo}
                    dataFinal={dataFimPeriodo}
                    cnpj={cnpjPagadorValue}
                    loteId={idLoteValue}
                  />
                )}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}

DadosGerais.propTypes = {
  dadosLote: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DadosGerais;
